import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeaseStatements = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#e58181",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "DocumentType",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "LeaseStatements",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Rectangle 16660",
				d: "M2.5 0.5H10.3789C10.644 0.50006 10.8985 0.605486 11.0859 0.792969L14.207 3.91406C14.3945 4.10155 14.4999 4.35596 14.5 4.62109V14.5C14.5 15.0523 14.0523 15.5 13.5 15.5H2.5C1.94772 15.5 1.5 15.0523 1.5 14.5V1.5C1.5 0.947715 1.94772 0.5 2.5 0.5Z",
				fill: "currentColor",
				fillOpacity: .25,
				stroke: "currentColor"
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Vector",
						d: "M3.79468 9.51842C3.79468 10.0639 4.01135 10.587 4.39703 10.9726C4.78271 11.3583 5.30581 11.575 5.85125 11.575C6.39668 11.575 6.91978 11.3583 7.30546 10.9726C7.69114 10.587 7.90781 10.0639 7.90781 9.51842C7.90781 8.97299 7.69114 8.44989 7.30546 8.06421C6.91978 7.67853 6.39668 7.46185 5.85125 7.46185C5.30581 7.46185 4.78271 7.67853 4.39703 8.06421C4.01135 8.44989 3.79468 8.97299 3.79468 9.51842Z",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_2",
						d: "M7.3114 8.06511L10.9447 4.42499L12.206 5.68635",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_3",
						d: "M9.49133 5.88519L10.4922 6.88606",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})
				]
			})]
		})
	})
});
export default SvgLeaseStatements;
